import 'intersection-observer';

import { accordion } from './accordion/accordion';
import { collapsable } from './collapsable/collapsable';
import { cookieBar } from './cookie-bar/cookieBar';
import { fancySelect } from './fancy-select/fancySelect';
import { form } from './form/form';
import { visibilityProbe } from './visibility-probe/visibilityProbe';
import { comment } from './comment/comment';
import { search, searchInputFocus } from "./search/search";
import { ImageGallery } from "./image-gallery/ImageGallery";
import {vimeoPlayer} from "./vimeo/vimeoPlayer";
import { OlMap } from "./ol-map/OlMap";
import { initializeDigest} from "./digest/digest";
import {scrollBlock} from "./scroll-block/scrollBlock";
import {menu} from "./menu/menu";
import {newsletterPopup} from "./newsletterPopup/newsletterPopup";


window.addEventListener('DOMContentLoaded', (): void => {
    cookieBar();
    accordion();
    form();
    scrollBlock()
    collapsable();
    fancySelect();
    visibilityProbe();
    search();
    searchInputFocus();
    comment();
    ImageGallery();
    vimeoPlayer();
    OlMap();
    initializeDigest();
    menu();
    newsletterPopup()
});
